//  Copyright (c) 2020 First Foundry Inc. All rights reserved.

export const PATH = 'transactionHistoryListCSV'
export const SET_START_DATE = `${PATH}/SET_START_DATE`
export const SET_END_DATE = `${PATH}/SET_END_DATE`
export const OPEN_TRANSACTION_LIST_CSV_REPORT = `${PATH}/OPEN_TRANSACTION_LIST_CSV_REPORT`
